const pageNameKey = "otaConfigurationUploadModal";

export const otaConfigurationUploadModalEn = {
  [pageNameKey]: {
    uploadingConfigurationText: "Uploading your configuration",
    descriptionStartText:
      "This may take a moment. Please do not close this window or refresh the page while the configuration is being uploaded.",
    helperText:
      "Configuration package is being verified and prepared for release.",
    uploadingConfiguration: "Uploading Configuration",

    configurationUploadFailedText: "Configuration upload failed",
    descriptionFailedText:
      "Something went wrong while uploading the configuration. Please try again.",
    helperFailedText:
      "The upload process was interrupted or the server returned an error. Please retry the upload.",

    configurationsUploadSuccessText: "Configuration uploaded successfully",
    descriptionSuccessText:
      "Your configuration has been uploaded and is ready to be used.",
    helperSuccessText:
      "The configuration package has been verified and stored successfully.",
    fileText: "File",
    sizeText: "Size",
  },
};

export const otaConfigurationUploadModalPtBr = {
  [pageNameKey]: {
    uploadingConfigurationText: "Enviando sua configuração",
    descriptionStartText:
      "Isso pode levar um momento. Não feche esta janela nem atualize a página enquanto a configuração está sendo enviada.",
    helperText:
      "O pacote de configuração está sendo verificado e preparado para o lançamento.",
    uploadingConfiguration: "Enviando configuração",

    configurationUploadFailedText: "Falha no upload da configuração",
    descriptionFailedText:
      "Algo deu errado ao enviar a configuração. Tente novamente.",
    helperFailedText:
      "O processo de upload foi interrompido ou o servidor retornou um erro. Tente enviar o arquivo novamente.",

    configurationsUploadSuccessText: "Configuração enviada com sucesso",
    descriptionSuccessText:
      "Sua configuração foi enviada e está pronta para ser usada.",
    helperSuccessText:
      "O pacote de configuração foi verificado e armazenado com sucesso.",
    fileText: "Arquivo",
    sizeText: "Tamanho",
  },
};

export const otaConfigurationUploadModalDe = {
  [pageNameKey]: {
    uploadingConfigurationText: "Ihre Konfiguration wird hochgeladen",
    descriptionStartText:
      "Dies kann einen Moment dauern. Bitte schließen Sie dieses Fenster nicht und aktualisieren Sie die Seite nicht, während die Konfiguration hochgeladen wird.",
    helperText:
      "Das Konfigurationspaket wird überprüft und für die Veröffentlichung vorbereitet.",
    uploadingConfiguration: "Konfiguration wird hochgeladen",

    configurationUploadFailedText: "Konfigurations-Upload fehlgeschlagen",
    descriptionFailedText:
      "Beim Hochladen der Konfiguration ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    helperFailedText:
      "Der Upload-Vorgang wurde unterbrochen oder der Server hat einen Fehler zurückgegeben. Bitte laden Sie die Konfiguration erneut hoch.",

    configurationsUploadSuccessText: "Konfiguration erfolgreich hochgeladen",
    descriptionSuccessText:
      "Ihre Konfiguration wurde hochgeladen und kann nun verwendet werden.",
    helperSuccessText:
      "Das Konfigurationspaket wurde erfolgreich überprüft und gespeichert.",
    fileText: "Datei",
    sizeText: "Größe",
  },
};

export const otaConfigurationUploadModalZhHans = {
  [pageNameKey]: {
    uploadingConfigurationText: "正在上传您的配置",
    descriptionStartText:
      "这可能需要一点时间。在配置上传过程中，请不要关闭此窗口或刷新页面。",
    helperText: "配置包正在验证并准备发布。",
    uploadingConfiguration: "正在上传配置",

    configurationUploadFailedText: "配置上传失败",
    descriptionFailedText: "上传配置时出现错误。请重试。",
    helperFailedText: "上传过程被中断或服务器返回错误。请重新上传配置。",

    configurationsUploadSuccessText: "配置上传成功",
    descriptionSuccessText: "您的配置已成功上传并可以使用。",
    helperSuccessText: "配置包已成功验证并存储。",
    fileText: "文件",
    sizeText: "大小",
  },
};

export const otaConfigurationUploadModalIt = {
  [pageNameKey]: {
    uploadingConfigurationText: "Caricamento della configurazione",
    descriptionStartText:
      "Potrebbe richiedere qualche minuto. Non chiudere questa finestra né aggiornare la pagina mentre la configurazione viene caricata.",
    helperText:
      "Il pacchetto di configurazione viene verificato e preparato per il rilascio.",
    uploadingConfiguration: "Caricamento configurazione",

    configurationUploadFailedText: "Caricamento configurazione fallito",
    descriptionFailedText:
      "Qualcosa è andato storto durante il caricamento della configurazione. Riprova.",
    helperFailedText:
      "Il processo di caricamento è stato interrotto o c'è stato un errore del server. Riprova il caricamento.",

    configurationsUploadSuccessText: "Configurazione caricata con successo",
    descriptionSuccessText:
      "La tua configurazione è stata caricata e è pronta per essere utilizzata.",
    helperSuccessText:
      "Il pacchetto di configurazione è stato verificato e salvato con successo.",
    fileText: "File",
    sizeText: "Dimensione",
  },
};

export const otaConfigurationUploadModalEs = {
  [pageNameKey]: {
    uploadingConfigurationText: "Subiendo tu configuración",
    descriptionStartText:
      "Esto puede tardar un momento. No cierres esta ventana ni actualices la página mientras se carga la configuración.",
    helperText:
      "El paquete de configuración se está verificando y preparando para su lanzamiento.",
    uploadingConfiguration: "Cargando configuración",

    configurationUploadFailedText: "La carga de la configuración falló",
    descriptionFailedText:
      "Se produjo un error al cargar la configuración. Inténtalo de nuevo.",
    helperFailedText:
      "El proceso de carga se interrumpió o el servidor devolvió un error. Vuelve a intentarlo.",

    configurationsUploadSuccessText: "Configuración cargada correctamente",
    descriptionSuccessText:
      "Tu configuración se ha cargado y está lista para usarse.",
    helperSuccessText:
      "El paquete de configuración se ha verificado y almacenado correctamente.",
    fileText: "Archivo",
    sizeText: "Tamaño",
  },
};

export const otaConfigurationUploadModalNl = {
  [pageNameKey]: {
    configurationUploadFailedText: "Configuratie-upload mislukt",
    configurationsUploadSuccessText: "Configuratie succesvol uploaded",
    descriptionFailedText:
      "Er is een fout opgetreden bij het uploaden van de configuratie. Probeer het opnieuw.",
    descriptionStartText:
      "Dit kan even duren. Sluit dit venster niet en vernieuw de pagina niet terwijl de configuratie wordt uploaded.",
    descriptionSuccessText:
      "Uw configuratie is uploaded en klaar voor gebruik.",
    fileText: "Bestand",
    helperFailedText:
      "Het uploadproces is onderbroken of de server heeft een fout geretourneerd. Upload de configuratie opnieuw.",
    helperSuccessText:
      "Het configuratiepakket is geverifieerd en succesvol opgeslagen.",
    helperText:
      "Configuratiepakket wordt geverifieerd en voorbereid voor uitgave.",
    sizeText: "Grootte",
    uploadingConfiguration: "Configuratie uploaden",
    uploadingConfigurationText: "Uw configuratie uploaded",
  },
};

export const otaConfigurationUploadModalTr = {
  [pageNameKey]: {
    configurationUploadFailedText: "Yapılandırma yüklemesi başarısız oldu",
    configurationsUploadSuccessText: "Yapılandırma başarıyla yüklendi",
    descriptionFailedText:
      "Yapılandırma yüklenirken bir şeyler ters gitti. Lütfen tekrar deneyin.",
    descriptionStartText:
      "Bu biraz zaman alabilir. Yapılandırma yüklenirken lütfen bu pencereyi kapatmayın veya sayfayı yenilemeyin.",
    descriptionSuccessText: "Yapılandırmanız yüklendi ve kullanıma hazır.",
    fileText: "Dosya",
    helperFailedText:
      "Yükleme işlemi kesintiye uğradı veya sunucu bir hata döndürdü. Lütfen yüklemeyi yeniden deneyin.",
    helperSuccessText: "Yapılandırma paketi doğrulandı ve başarıyla saklandı.",
    helperText: "Yapılandırma paketi doğrulanıyor ve yayına hazırlanıyor.",
    sizeText: "Boyut",
    uploadingConfiguration: "Yapılandırma Yükleniyor",
    uploadingConfigurationText: "Yapılandırmanız yükleniyor",
  },
};
